import { Alert } from '@mui/material';
import React, { useEffect, useState } from 'react';

type CountdownProps = {
  targetTime: Date; // z.B. neue Date("2025-05-02T15:30:00Z")
};

const CountdownSoftLock: React.FC<CountdownProps> = ({ targetTime }) => {
  const [timeLeft, setTimeLeft] = useState<number>(
    Math.max(0, targetTime.getTime() - Date.now())
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const delta = targetTime.getTime() - Date.now();
      setTimeLeft(Math.max(0, delta));
    }, 1000);

    return () => clearInterval(interval); // Aufräumen
  }, [targetTime]);

  // In Sekunden umwandeln und formatieren
  const seconds = Math.floor(timeLeft / 1000);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  if (Date.now() > targetTime.getTime()) {
    return <></>;
  }
  return (
    <Alert severity='error' sx={{ maxWidth: 300 }}>
      Ihr Konto ist für{' '}
      <b>
        {mins.toString().padStart(2, '0')}:{secs.toString().padStart(2, '0')}{' '}
        Minuten
      </b>{' '}
      gesperrt. <br />
      <br /> Um die Sperre aufzuheben, können Sie Ihr Passwort alternativ auch
      selbst zurücksetzen und ein neues Passwort vergeben.
    </Alert>
  );
};

export default CountdownSoftLock;
